// ref: https://github.com/streamich/react-use/blob/master/src/useThrottle.ts

import { useEffect, useRef, useState } from 'react';

export const useThrottle = <T>(value: T, ms = 200) => {
  const [state, setState] = useState(value);
  const timeout = useRef<ReturnType<typeof setTimeout>>();
  const nextValue = useRef<T | null>(null);
  const hasNextValue = useRef<0 | boolean>(0);

  useEffect(() => {
    if (!timeout.current) {
      setState(value);
      const timeoutCallback = () => {
        if (hasNextValue.current) {
          hasNextValue.current = false;
          setState(nextValue.current as T);
          timeout.current = setTimeout(timeoutCallback, ms);
        } else {
          timeout.current = undefined;
        }
      };
      timeout.current = setTimeout(timeoutCallback, ms);
    } else {
      nextValue.current = value;
      hasNextValue.current = true;
    }
  }, [ms, value]);

  useEffect(() => () => timeout.current && clearTimeout(timeout.current), []);

  return state;
};
